import ACTIONS, { FETCH_STATUS } from "../constants";
  
// SORT PURCHASE_ORDER

export const sortPurchaseOrderRequest = (state) => ({
  type: ACTIONS.SORT_PURCHASE_ORDERS_CALL,
  payload: state,
});

export const sortPurchaseOrderRequestAttempt = {
  pending: {
    type: ACTIONS.SORT_PURCHASE_ORDERS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_PURCHASE_ORDERS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_PURCHASE_ORDERS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// GET PURCHASE_ORDER

export const getPurchaseOrdersRequest = (state) => ({
  type: ACTIONS.PURCHASE_ORDERS_CALL,
  payload: state,
});

export const getPurchaseOrdersAttempt = {
  pending: {
    type: ACTIONS.PURCHASE_ORDERS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PURCHASE_ORDERS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PURCHASE_ORDERS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};


// CREATE PURCHASE_ORDER

export const createPurchaseOrderRequest = (state) => ({
  type: ACTIONS.CREATE_PURCHASE_ORDER_CALL,
  payload: state,
});

export const createPurchaseOrderAttempt = {
  pending: {
    type: ACTIONS.CREATE_PURCHASE_ORDER.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_PURCHASE_ORDER.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_PURCHASE_ORDER.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// UPDATE PURCHASE_ORDER

export const updatePurchaseOrderRequest = (state) => ({
  type: ACTIONS.UPDATE_PURCHASE_ORDER_CALL,
  payload: state,
});

export const updatePurchaseOrderAttempt = {
  pending: {
    type: ACTIONS.UPDATE_PURCHASE_ORDER.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_PURCHASE_ORDER.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_PURCHASE_ORDER.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// DELETE PURCHASE_ORDER

export const deletePurchaseOrderRequest = (state) => ({
  type: ACTIONS.DELETE_PURCHASE_ORDER_CALL,
  payload: state,
});

export const deletePurchaseOrderAttempt = {
  pending: {
    type: ACTIONS.DELETE_PURCHASE_ORDER.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_PURCHASE_ORDER.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_PURCHASE_ORDER.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// FLAG PURCHASE_ORDER

export const updatePurchaseOrderFlag = (state) => ({
  type: ACTIONS.PURCHASE_ORDER_FLAG_CALL,
  payload: state,
});

export const updatePurchaseOrderFlagAttempt = {
  pending: {
    type: ACTIONS.PURCHASE_ORDER_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PURCHASE_ORDER_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PURCHASE_ORDER_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};